/**
 * F7 라우터 beforeEnter 가드 (Issue #447 Phase G)
 *
 * 보호 라우트 접근 시 Supabase 세션을 확인하고 미인증이면 /login으로 redirect.
 * 인증 라우트(/login·/auth/callback) 접근 시 이미 인증되었으면 / 로 redirect.
 *
 * F7 v9 beforeEnter 시그니처: (ctx: RouteCallbackCtx) => void
 *   ctx.resolve()  → 라우트 진입 허용
 *   ctx.reject()   → 라우트 진입 차단 (이전 위치 유지)
 * reject 후 ctx.router.navigate('/login') 으로 명시적 redirect.
 */

import type { Router } from 'framework7/types';
import { supabase } from './supabase';

type BeforeEnterCtx = Router.RouteCallbackCtx;

const NAV_OPTS = {
  reloadAll: true,
  animate: false,
  clearPreviousHistory: true,
} as const;

/** 미인증이면 /login 으로, 인증되면 통과. */
export async function requireAuth(ctx: BeforeEnterCtx): Promise<void> {
  try {
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      ctx.resolve();
      return;
    }
  } catch (err) {
    console.warn('[auth-guard] getSession 실패, /login으로 redirect:', err);
  }
  ctx.reject();
  ctx.router.navigate('/login', NAV_OPTS);
}

/** 이미 인증되어 있으면 / 로, 아니면 통과. /login·/auth/callback 진입 시 사용. */
export async function skipIfAuthed(ctx: BeforeEnterCtx): Promise<void> {
  try {
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      ctx.reject();
      ctx.router.navigate('/', NAV_OPTS);
      return;
    }
  } catch (err) {
    console.warn('[auth-guard] getSession 실패, 가드 무시:', err);
  }
  ctx.resolve();
}
